import { Phone } from "lucide-react";

export const Nav = () => (
  <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0b101b]/80 backdrop-blur-md" data-testid="site-nav">
    <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-6">
      <a href="#hero" className="group flex items-center gap-3" data-testid="nav-logo-link">
        <svg className="h-8 w-8 flex-shrink-0 text-[#38bdf8]" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" className="opacity-30" />
          <path d="M4 16h24M16 4v24M8 10l16 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" pathLength="1" className="d1-draw-path" />
        </svg>
        <span className="font-disp text-2xl uppercase tracking-wide text-white">EL &amp; MJ TRAVEL</span>
      </a>
      <nav className="hidden items-center gap-8 font-mono-lbl text-xs uppercase tracking-widest text-slate-400 md:flex">
        <a href="#book" className="transition-colors hover:text-[#38bdf8]" data-testid="nav-link-rates">Fixed Rates</a>
        <a href="#fleet" className="transition-colors hover:text-[#38bdf8]" data-testid="nav-link-fleet">Executive Fleet</a>
        <a href="#coverage" className="transition-colors hover:text-[#38bdf8]" data-testid="nav-link-radar">Flight Radar</a>
        <a href="#guarantee" className="transition-colors hover:text-[#38bdf8]" data-testid="nav-link-trust">Trust</a>
      </nav>
      <div className="flex items-center gap-4">
        <a
          href="tel:+447982651409"
          data-testid="nav-phone-link"
          className="hidden items-center gap-2 font-mono-lbl text-xs tracking-wider text-slate-300 transition-colors hover:text-[#38bdf8] sm:flex"
        >
          <Phone className="h-3.5 w-3.5 text-[#38bdf8]" />
          07982 651 409
        </a>
        <a
          href="#book"
          data-testid="nav-instant-quote-button"
          className="inline-flex items-center gap-2 rounded-full bg-[#38bdf8] px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-[#0b101b] shadow-[0_0_24px_rgba(56,189,248,0.35)] transition-colors hover:bg-white"
        >
          <span>Instant Quote</span>
          <span>&rarr;</span>
        </a>
      </div>
    </div>
  </header>
);
